module.exports = __webpack_public_path__ + "static/images/eye-with-cross.1141a7fe4990d70208643187ed47328f.svg";